<template lang="pug">
.auth-page
  .row
    .register-form
      .d-flex.flex-row
        a.logo(href="")
          img(src="@/assets/images/xendity-logo.png", alt="")
        .d-flex.flex-row.tag-groups
          span.mr-4 SECURE
          span.mr-4 &#183;
          span.mr-4 IMMUTABLE
          span.mr-4 &#183;
          span.mr-4 IRREFUTABLE
      .py-4
        h1 Let's Get Started
        h4.mb-5 No credit card required. Already have an account?
          a.change-link(@click="switchMode('login')") Login.
        div
          .form-row.mb-4
            .col
              input#firstName.form-control(
                type="text",
                placeholder="First name",
                v-model="$v.register.firstName.$model"
              )
              small.text-danger.my-1.ml-4(
                v-if="$v.register.firstName.$dirty && !$v.register.firstName.required"
              ) First name is required.
            .col
              input#lastName.form-control(
                type="text",
                placeholder="Last name",
                v-model="$v.register.lastName.$model"
              )
              small.text-danger.my-1.ml-4(
                v-if="$v.register.lastName.$dirty && !$v.register.lastName.required"
              ) Last name is required.
          .form-row.mb-4
            .col
              select.form-control(v-model="type")
                option(value="1") Individual
                option(value="2") Corporate
              small.ml-4 Account Type
            .col
              input#exampleInputCompany.form-control(
                type="text",
                placeholder="Enter company name",
                v-model="register.company"
              )
              small.text-info.ml-4 *Optional
          .form-row.mb-4
            .col
              input#exampleInputUsername.form-control(
                type="text",
                placeholder="Enter username",
                v-model="$v.register.username.$model"
              )
              small.text-danger.my-1.ml-4(
                v-if="$v.register.username.$dirty && !$v.register.username.required"
              ) Username is required.
              small.text-danger.my-1.ml-4(
                v-if="$v.register.username.$dirty && !$v.register.username.minLength"
              ) Username must be more than 5 characters.
              small.text-danger.my-1.ml-4(
                v-if="$v.register.username.$dirty && !$v.register.username.maxLength"
              ) Username cannot be more than 20 characters.
              small.text-danger.my-1.ml-4(
                v-if="$v.register.username.$dirty && !$v.register.username.alphaNumAndDotValidator"
              ) Only alpha numeric is allowed.
          .form-row.mb-4
            .col
              input#exampleInputEmail1.form-control(
                type="email",
                aria-describedby="emailHelp",
                placeholder="Enter email",
                v-model="$v.register.email.$model"
              )
              small.text-danger.my-1.ml-4(
                v-if="$v.register.email.$dirty && !$v.register.email.required"
              ) E-mail is required.
              small.text-danger.my-1.ml-4(
                v-if="$v.register.email.$dirty && !$v.register.email.email"
              ) E-mail format is incorrect.
          .form-row.mb-4
            .col
              input#inputPassword.form-control(
                type="password",
                placeholder="Password",
                v-model="$v.register.password.$model"
              )
              small.text-danger.my-1.ml-4(
                v-if="$v.register.password.$dirty && !$v.register.password.required"
              ) Password is required.
              small.text-danger.my-1.ml-4(
                v-if="$v.register.password.$dirty && !$v.register.password.minLength"
              ) Password must be more than 5 characters.
          .form-row.mb-4
            .col
              input#confirmPassword.form-control(
                type="password",
                aria-describedby="passwordHelp",
                placeholder="Confirmation Password",
                v-model="$v.register.repeatPassword.$model"
              )
              small.text-info.my-1.ml-4(
                v-if="!$v.register.repeatPassword.$dirty"
              ) Make sure the passwords input are the same.
              small.text-danger.my-1.ml-4(
                v-if="$v.register.repeatPassword.$dirty && !$v.register.repeatPassword.required"
              ) Confirmation password is required.
              small.text-danger.my-1.ml-4(
                v-if="$v.register.repeatPassword.$dirty && !$v.register.repeatPassword.sameAsPassword"
              ) Confirmation password must be the same as password.
          button.btn.btn-blue.mb-5(@click="registerUser") Create My Free Account
      div
        p.disclaimer We will occasionally email you about Xendity’s products and features but, if you would rather not receive these email, please <a href="">click here</a> to unsubscribe.
        p.disclaimer By register you agree to our <a href="">Terms of Service, Privacy Policy</a>.
    img(
      width="35%",
      height="100%",
      src="@/assets/images/register-banner.jpg",
      alt=""
    )
    .register-form
      .d-flex.flex-row
        a.logo(href="")
          img(src="@/assets/images/xendity-logo.png", alt="")
        .d-flex.flex-row.tag-groups
          span.mr-4 SECURE
          span.mr-4 &#183;
          span.mr-4 IMMUTABLE
          span.mr-4 &#183;
          span.mr-4 IRREFUTABLE
      .py-4
        h1 Welcome Back!
        h4.mb-5 We missed you. Don't have an account yet?
          a.change-link(@click="switchMode('register')") Register.
        div
          .form-row.mb-4
            .col
              input.form-control(
                type="text",
                placeholder="Username",
                v-model.trim="$v.login.loginUsername.$model"
              )
              small.text-danger.my-1.ml-4(
                v-if="$v.login.loginUsername.$dirty && !$v.login.loginUsername.required"
              ) Username is required.
              small.text-danger.my-1.ml-4(
                v-if="$v.login.loginUsername.$dirty && !$v.login.loginUsername.minLength"
              ) Username must be more than 5 characters.
              small.text-danger.my-1.ml-4(
                v-if="$v.login.loginUsername.$dirty && !$v.login.loginUsername.maxLength"
              ) Username cannot be more than 20 characters.
              small.text-danger.my-1.ml-4(
                v-if="$v.login.loginUsername.$dirty && !$v.login.loginUsername.alphaNumAndDotValidator"
              ) Only alpha numeric is allowed.
          .form-row.mb-4
            .col
              input.form-control(
                type="password",
                placeholder="Password",
                v-model.trim="$v.login.loginPassword.$model"
              )
              small.text-danger.my-1.ml-4(
                v-if="$v.login.loginPassword.$dirty && !$v.login.loginPassword.required"
              ) Password is required.
              small.text-danger.my-1.ml-4(
                v-if="$v.login.loginPassword.$dirty && !$v.login.loginPassword.minLength"
              ) Password must be more than 5 characters.
              .input-group.my-2.ml-4
                input#consent.mx-2.my-auto(
                  type="checkbox",
                  v-model.trim="$v.login.consent.$model"
                )
                label.m-0(for="consent") 
                  p.disclaimer.m-0 Please agree to Terms of Use and Privacy Policy before logging in.
              small.text-danger.ml-4(
                v-if="$v.login.consent.$dirty && !$v.login.consent.sameAs"
              ) Please agree before logging in.
          button.btn.btn-blue.mb-5(@click="loginUser") Login
          button.btn.btn-transparent.ml-3.mb-5(@click="requestReset") Reset password?
      div
        p.disclaimer We will occasionally email you about Xendity’s products and features but, if you would rather not receive these email, please <a href="">click here</a> to unsubscribe.
        p.disclaimer By register you agree to our <a href="">Terms of Service, Privacy Policy</a>.
</template>

<script>
import { validationMixin } from "vuelidate";
import {
  required,
  minLength,
  maxLength,
  email,
  sameAs,
  helpers,
} from "vuelidate/lib/validators";
const alphaNumAndDotValidator = helpers.regex(
  "alphaNumAndDot",
  /^[a-z\d._]*$/i
);

export default {
  mixins: [validationMixin],
  data() {
    return {
      login: {
        loginUsername: "",
        loginPassword: "",
        consent: false,
      },
      register: {
        firstName: "",
        lastName: "",
        username: "",
        password: "",
        repeatPassword: "",
        email: "",
        company: "",
      },
      mode: "",
      type: 1,
    };
  },
  computed: {
    fullName() {
      return this.register.firstName + " " + this.register.lastName;
    },
  },
  validations: {
    login: {
      loginUsername: {
        required,
        minLength: minLength(5),
        maxLength: maxLength(20),
        alphaNumAndDotValidator,
      },
      loginPassword: { required, minLength: minLength(6) },
      consent: {
        sameAs: sameAs(() => true),
      },
    },
    register: {
      firstName: {
        required,
      },
      lastName: {
        required,
      },
      username: {
        required,
        minLength: minLength(5),
        maxLength: maxLength(20),
        alphaNumAndDotValidator,
      },
      email: { required, email },
      password: { required, minLength: minLength(6) },
      repeatPassword: {
        required,
        sameAsPassword: sameAs(function () {
          return this.register.password;
        }),
      },
    },
  },
  mounted() {
    this.mode = this.$route.query.mode;
    this.$nextTick(() => {
      this.switchMode(this.mode);
    });
  },
  beforeDestroy() {
    $(document).off("keypress");
  },
  methods: {
    switchMode(val) {
      this.mode = val;

      if (this.$route.query.mode != this.mode)
        this.$router.replace({
          query: {
            mode: this.mode,
          },
        });

      if (this.mode === "register")
        $(".row").css({ "-webkit-transform": "translateX(0)" });
      if (this.mode === "login")
        $(".row").css({ "-webkit-transform": "translateX(-70%)" });

      $(document).off("keypress");
      if (this.mode === "register")
        $(document).keypress((event) => {
          var keycode = event.keyCode ? event.keyCode : event.which;
          if (keycode == "13") this.registerUser();
        });

      if (this.mode === "login")
        $(document).keypress((event) => {
          var keycode = event.keyCode ? event.keyCode : event.which;
          if (keycode == "13") this.loginUser();
        });
    },
    registerUser() {
      this.$v.register.$touch();

      if (this.$v.register.$invalid) return;
      this.$store
        .dispatch("user/register", {
          full_name: this.fullName,
          email: this.register.email,
          company: this.register.company,
          type: this.type,
          username: this.register.username,
          password: this.register.repeatPassword,
        })
        .then((response) => {
          if (response.status == 400)
            this.$swal(response.error_message, "Error", "error");
          else {
            this.$swal(
              response.message,
              "Please check your e-mail for verification mail",
              "success"
            ).then((result) => {
              if (result.isConfirmed) {
                this.switchMode("login");
              }
            });
          }
        });
    },
    loginUser() {
      this.$v.login.$touch();

      if (this.$v.login.$invalid) return;
      this.$store
        .dispatch("user/login", {
          username: this.login.loginUsername,
          password: this.login.loginPassword,
        })
        .then((response) => {
          if (response.status == 400)
            this.$swal(response.error_message, "Error", "error");
          else if (response.status == 300)
            this.$swal(
              response.message,
              "Go to verification page",
              "error"
            ).then((result) => {
              if (result.isConfirmed) {
                this.$router.push("verify");
              }
            });
          else {
            if (response.role_id == "admin")
              this.$router.push("portal/admin/package");

            if (response.role_id == "user") {
              if (response.has_package)
                this.$router.push("portal/user/service");
              else this.$router.push("portal/user/purchase");
            }
          }
        });
    },
    requestReset() {
      this.$v.login.loginUsername.$touch();

      if (this.$v.login.loginUsername.$error) return;
      this.$store
        .dispatch("user/request", {
          username: this.login.loginUsername,
        })
        .then((response) => {
          if (response.status == 400)
            this.$swal(response.error_message, "Error", "error");
          else {
            this.$swal(
              response.message,
              "Password reset request successful. Please check your e-mail.",
              "success"
            );
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/auth.scss";
</style>